import * as types from '../actions/forms/types';


const INITIAL_STATE = {
  activeForm: {},
  formHeaders: [],
};

export default function formsReducer(state = INITIAL_STATE, action) {

  switch (action.type) {
    case types.GET_FORM_HEADERS_PRIVATE:
      return {
        ...state,
        formHeaders: action.payload
      };

    case types.GET_FORM_HEADERS_PUBLIC:
      return {
        ...state,
        formHeaders: action.payload
      };

    case types.GET_FORM_PRIVATE:
      return {
        ...state,
        activeForm: action.payload
      };

    case types.GET_FORM_PUBLIC:
      return {
        ...state,
        activeForm: action.payload
      };

    default:
      return state;
  }

}



// WEBPACK FOOTER //
// ./src/reducers/formsReducer.js